import { connect } from 'react-redux';
import {
  themeConfiguration,
  routesConfiguration,
  faviconConfiguration,
} from '../../selectors';
import MainComponent from './Main.component';

import ErrorActions from 'domains/core/error/actions';

export const mapStateToProps = state => ({
  theme: themeConfiguration(state),
  routes: routesConfiguration(state),
  favicon: faviconConfiguration(state),
});

export const mapDispatchToProps = {
  unrecoverable: e => ErrorActions.unrecoverable(e),
};

export default connect(mapStateToProps, mapDispatchToProps)(MainComponent);
